import { createTRPCProxyClient, httpLink } from '@trpc/client'
import { AppRouter } from '@vae/server'

const baseUrl = process.env.react_app_rest_url || process.env.REACT_APP_REST_URL

const authClient = createTRPCProxyClient<AppRouter>({
	links: [
		httpLink({
			url: `${baseUrl}trpc`,
			fetch: (url, options) => {
				return fetch(url, {
					...options,
					credentials: 'include',
				})
			},
		}),
	],
})

export default authClient
